"use client";
/**
 * Optional shared-config provider: put connection/theming config here once
 * and every `LootBoxOpener` below inherits it (explicit props still win).
 */
import { type ReactNode, useMemo } from "react";
import { useShopperSoundLevel } from "../sounds/useOpenerSounds";
import { LootConfigContext, type LootProviderConfig } from "./LootConfigContext";

/** Publishes shared opener config to every `LootBoxOpener` below it. */
export function LootProvider({
  children,
  ...config
}: LootProviderConfig & { children?: ReactNode }) {
  useShopperSoundLevel(
    config.soundMuted !== undefined || config.soundVolume !== undefined
      ? { muted: config.soundMuted, volume: config.soundVolume }
      : null,
    "provider",
  );
  // biome-ignore lint/correctness/useExhaustiveDependencies: config is spread-stable per prop identity
  const value = useMemo(
    () => config,
    [
      config.publishableKey,
      config.baseUrl,
      config.sessionToken,
      config.sessionPending,
      config.onSessionExpired,
      config.client,
      config.createClient,
      config.theme,
      config.sounds,
      config.soundBaseUrl,
      config.soundEvents,
      config.soundMuted,
      config.soundVolume,
      config.onSoundMutedChange,
      config.locale,
      config.currency,
    ],
  );
  return <LootConfigContext.Provider value={value}>{children}</LootConfigContext.Provider>;
}
